import React from 'react';
import { motion } from 'framer-motion';
export function Section4() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="bg-[#4DC61A]/5 py-16" data-id="element-78">
      <div className="max-w-3xl mx-auto px-6" data-id="element-79">
        <h2 className="font-sans font-bold text-3xl text-[#0F4226] mb-8" data-id="element-80">
          4. The Natural Graveyard — Why the Alternatives Failed Too
        </h2>

        <div className="mb-8" data-id="element-81">
          <img src="https://cdn.magicpatterns.com/uploads/pyD9fes75DXUg2NFWi5V6P/Dog_resting_in_202604192244_(3).jpg" alt="Failed natural flea products scattered on the floor" className="w-full rounded shadow-md" data-id="element-82" />
        </div>

        <div className="font-sans text-lg leading-relaxed text-[#666666] space-y-6" data-id="element-83">
          <p className="text-xl font-semibold text-[#0F4226]" data-id="element-84">
            If you've tried natural sprays and still found ticks — you're not
            imagining things. They did fail. This isn't your fault.
          </p>
          <p data-id="element-85">
            The problem isn't that natural doesn't work. The problem is how
            every natural product on the market tries to deliver it.
          </p>

          <h3 className="font-sans font-bold text-2xl mt-8 mb-4 text-[#0F4226]" data-id="element-86">
            The Mechanism Problem
          </h3>
          <p data-id="element-87">
            Every natural product — sprays, topicals, herbal collars — fights
            the battle <em data-id="element-88">after</em> the parasite has already located the host.
            They create a scent barrier or a topical deterrent on the skin. But
            fleas and ticks detect hosts from a distance — heat, CO2, body odor
            — before they ever make physical contact.
          </p>

          <div className="space-y-4 my-8" data-id="element-89">
            <div className="bg-white p-6 rounded shadow-sm" data-id="element-90">
              <h4 className="font-sans font-bold text-lg mb-2 text-[#0F4226]" data-id="element-91">
                Why Sprays Fail
              </h4>
              <p data-id="element-92">
                They require reapplication every 2-3 days, wash off in rain or
                bathing, provide inconsistent coverage across the coat, and
                leave gaps in protection every time she misses a day.
              </p>
            </div>

            <div className="bg-white p-6 rounded shadow-sm" data-id="element-93">
              <h4 className="font-sans font-bold text-lg mb-2 text-[#0F4226]" data-id="element-94">
                Why Herbal Collars Fail
              </h4>
              <p data-id="element-95">
                The essential oil scent that provides the active repellent
                function fades within 2-3 weeks, often to zero. The collar
                becomes decorative long before you realize it's stopped working.
              </p>
            </div>

            <div className="bg-white p-6 rounded shadow-sm" data-id="element-96">
              <h4 className="font-sans font-bold text-lg mb-2 text-[#0F4226]" data-id="element-97">
                Why DIY Fails
              </h4>
              <p data-id="element-98">
                Concentration levels are inconsistent, delivery is intermittent,
                and the application process is high-maintenance enough that
                compliance degrades over time.
              </p>
            </div>
          </div>

          <p className="text-2xl font-medium italic text-[#0F4226] my-8 text-center" data-id="element-99">
            "False peace of mind is worse than no peace of mind."
          </p>

          <p className="text-xl font-semibold text-[#0F4226]" data-id="element-100">
            The ancient wisdom worked. The delivery methods available to the
            modern pet parent have been the problem all along.
          </p>
        </div>
      </div>
    </motion.section>;
}